export const provider = {
  touchNgo: "TOUCH_N_GO",
};
